// extracted by mini-css-extract-plugin
export default {"APIConfigPage-config-container":"APIConfigPage-config-container1CRE0CR0JoDI","APIConfigPage-config-blocks":"APIConfigPage-config-blockstQiivrNyelsM"};